import { bucketColor, ALTITUDE_BUCKETS, ALTITUDE_MAX_FT } from '../map/altitude';

const TICKS_FT = [10_000, 20_000, 30_000];

/** Horizontal color scale explaining the altitude gradient used for icons/trails. */
export default function AltitudeLegend() {
  const stops = Array.from({ length: ALTITUDE_BUCKETS }, (_, i) => bucketColor(i));
  const gradient = `linear-gradient(to right, ${stops.join(', ')})`;
  const maxFl = Math.round(ALTITUDE_MAX_FT / 100);

  return (
    <div
      className="altitude-legend glass"
      role="img"
      aria-label={`Altitude color legend, from ground level in red to flight level ${maxFl} and above in blue`}
    >
      <span className="legend-label mono">GND</span>
      <div className="legend-scale">
        <div className="legend-bar" style={{ background: gradient }} />
        {TICKS_FT.map((ft) => (
          <span key={ft} className="legend-tick mono" style={{ left: `${(ft / ALTITUDE_MAX_FT) * 100}%` }}>
            {ft / 1000}k
          </span>
        ))}
      </div>
      <span className="legend-label mono">FL{maxFl}+</span>
    </div>
  );
}
